import { getV2Endpoint } from '@/utils/apiV2Endpoints';
import KmsHttpService from '@/servises/kmsHttpService';

export default {
    deleteLocation: (id) => {
        const endpoint = getV2Endpoint({ 'group': 'locations', 'endpoint': 'manage' }, { id: id });
        return KmsHttpService.delete(endpoint, null);
    }
};
